import isArrayLike from 'is-array-like';

function toArray(args, start) {
  if (!isArrayLike(args) && args !== "") {
    throw new TypeError(args + " can't be converted to array.");
  }

  if (start == null) {
    start = 0;
  }

  if (typeof start !== "number" || !isFinite(start)) {
    throw new TypeError(start + " is not a valid start point.");
  }

  var len = args.length;

  if (start < 0) {
    start += len;
  }

  var argsObj = Object(args);
  var result = new Array(len - start);

  for (var i = start; i < len; i++) {
    if (i in argsObj) {
      result[i - start] = argsObj[i];
    }
  }

  return result;
}

export default toArray;
//# sourceMappingURL=args-to-arr.es.js.map
